/* tslint:disable */
/* eslint-disable */
/**
 * Careplatform file management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: jonas.malik@magello.se
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FileMetadata,
    FileMetadataFromJSON,
    FileMetadataFromJSONTyped,
    FileMetadataToJSON,
    Pagination,
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
} from './';

/**
 * 
 * @export
 * @interface PaginatedFilterList
 */
export interface PaginatedFilterList {
    /**
     * 
     * @type {Pagination}
     * @memberof PaginatedFilterList
     */
    pagination: Pagination;
    /**
     * 
     * @type {Array<FileMetadata>}
     * @memberof PaginatedFilterList
     */
    data?: Array<FileMetadata>;
}

export function PaginatedFilterListFromJSON(json: any): PaginatedFilterList {
    return PaginatedFilterListFromJSONTyped(json, false);
}

export function PaginatedFilterListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedFilterList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pagination': PaginationFromJSON(json['pagination']),
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(FileMetadataFromJSON)),
    };
}

export function PaginatedFilterListToJSON(value?: PaginatedFilterList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'pagination': PaginationToJSON(value.pagination),
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(FileMetadataToJSON)),
    };
}


